module.exports = __webpack_public_path__ + "static/media/register.0f7f37a0.svg";